import { format } from 'date-fns';

export const formatAirDate = (airDate: string, dateFormat: string) => format(new Date(airDate), dateFormat);
